module.exports = fox._r("images/download.gif", __webpack_public_path__ + "images/download.gif");


//////////////////
// WEBPACK FOOTER
// ./images/download.gif
// module id = 1039
// module chunks = 4